<template>
  <div class="alert" :class="alertClass" role="alert">
    <strong>{{ headline }}</strong><slot />

    <button
      v-if="dismissible"
      type="button"
      class="btn-close"
      data-bs-dismiss="alert"
      aria-label="Close"
      @click="onClose"
    />
  </div>
</template>

<script>
export default {
  emits: ['closed'],
  props: {
    type: {
      type: String,
      default: '', // success, alert, warning
    },
    headline: {
      type: String,
      default: null,
    },
    dismissible: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    alertClass() {
      return [`alert-${this.type}`, (this.dismissible ? ' alert-dismissible fade show' : '')];
    },
  },

  methods: {
    onClose() {
      this.$emit('closed');
    },
  },
};
</script>
